import type { LeadNote } from "../../types/lead.types.ts"

/**
 * The one canonical order: pinned notes first (stable — their relative order
 * among themselves is preserved, not re-sorted), then unpinned notes
 * newest-created-first. `LeadNotesSection` computes this once and passes the
 * same array to whichever view (Board/List) is active, so they never
 * disagree on order.
 */
function sortNotes(notes: LeadNote[]): LeadNote[] {
  const pinned = notes.filter((note) => note.is_pinned)
  const unpinned = notes
    .filter((note) => !note.is_pinned)
    .slice()
    .sort(
      (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
    )

  return [...pinned, ...unpinned]
}

export { sortNotes }
